import fr from 'facet-rest';
import React, { useEffect } from 'react';
import { LottieControl } from 'Components/ComponentLibrary/Organisms/LottieControl';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import PropTypes from 'prop-types';

export const AccountDebitLottie = ({ resource }) => {
  const { setIsContentShowing } = useLottieLoadingContext();

  useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return resource.withRelationship(fr.relationships.lottie.name,
    (rel) => (<LottieControl
      src={rel.link('related').url()}
      onLoadSuccess={() => setIsContentShowing(true)}
      onLoadError={() => setIsContentShowing(true)}
      height={'auto'}
      width={'auto'}
    />),
    () => null);
};

AccountDebitLottie.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
